import { motion } from 'framer-motion';
import { scrollToId } from './SmoothScroll';

const SOCIALS = [
  { label: 'Dribbble', href: 'https://dribbble.com' },
  { label: 'Behance', href: 'https://behance.net' },
  { label: 'LinkedIn', href: 'https://linkedin.com' },
  { label: 'Instagram', href: 'https://instagram.com' },
];

export default function Footer() {
  return (
    <footer className="border-t border-border">
      <div className="mx-auto max-w-[1600px] px-6 py-16 md:px-12 md:py-20">
        <motion.button
          onClick={() => scrollToId('hero')}
          initial={{ opacity: 0.5 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="block w-full text-left font-display text-[18vw] font-extrabold uppercase leading-[0.8] tracking-tighter text-foreground md:text-[13vw]"
          data-testid="footer-brand"
        >
          Michele Rago
        </motion.button>

        <div className="mt-16 flex flex-col justify-between gap-10 border-t border-border pt-10 md:flex-row">
          <div className="max-w-xs">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
              Based in Milan — working worldwide - P.iva 02953490188
            </p>
            <p className="mt-4 text-sm text-muted-foreground">
              Available for freelance & full-time — 2025 / 2026.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-10 gap-y-4">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative font-mono text-xs uppercase tracking-[0.15em] text-muted-foreground transition-colors hover:text-foreground"
                data-testid={`footer-social-${s.label.toLowerCase()}`}
              >
                {s.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-foreground transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-2 font-mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground/70 md:flex-row">
          <span>© 2025 Michele Rago. All rights reserved.</span>
          <span>Designed & built with intent.</span>
        </div>
      </div>
    </footer>
  );
}
